module.exports = __webpack_public_path__ + "static/rainbowspotmain-e1c377aee6b0b07a1bc7944dc9966e96.png";